var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.126,
    height: 22.126,
    viewBox: "0 0 22.126 22.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#7c7c7c;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.457,1.364V0H.682A.682.682,0,0,0,0,.682V5.457H1.364V2.326L7.7,8.662,8.662,7.7,2.326,1.364Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M316.78,0h-4.774V1.364h3.131l-3.444,3.444L308.8,7.7l.962.962L316.1,2.326V5.457h1.364V.682A.682.682,0,0,0,316.78,0Z",
    transform: "translate(-295.636 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M316.1,315.136l-6.336-6.336-.962.962,6.336,6.336h-3.131v1.364h4.774a.682.682,0,0,0,.682-.682v-4.774H316.1Z",
    transform: "translate(-295.636 -295.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.7,308.64l-6.336,6.343v-3.131H0v4.775a.682.682,0,0,0,.682.682H5.457v-1.364H2.326l6.336-6.336Z",
    transform: "translate(0 -295.483)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.dd3a65ff.svg";
export { ForwardRef as ReactComponent };